import { ActionContext, ActionTree } from 'vuex'
import { RootState } from '@/Infrastructure/Store/RootState'
import { ProcedureState } from './ProcedureState'
import { ProcedureDto } from '@/Application/Procedures'
import { BatchDto } from '@/Application/Batch'

export const actions: ActionTree<ProcedureState, RootState> = {
  setCurrentProcedure: (context: ActionContext<ProcedureState, RootState>, payload: ProcedureDto) => {
    context.commit('setCurrentProcedure', payload)
  },
  setProcedureBatches: (
    context: ActionContext<ProcedureState, RootState>,
    payload: { risco: BatchDto[]; resultas: BatchDto[] }
  ) => {
    context.commit('setRiscoBatches', payload.risco)
    context.commit('setResultasBatches', payload.resultas)
  }
}
